import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import router from './router'
import RouteHistory from './routeHistory'
import CurrentUser from './currentUser'
import Noembed from './noembed'

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(RouteHistory, { router })
Vue.use(CurrentUser)
Vue.use(Noembed)

export { router }
